import project01 from "./../img/projects/01.jpg";
import project01Big from "./../img/projects/01-big.jpg";

import project02 from "./../img/projects/02.jpg";
import project02Big from "./../img/projects/02-big.jpg";

import project03 from "./../img/projects/03.jpg";
import project03Big from "./../img/projects/03-big.jpg";

import project04 from "./../img/projects/04.jpg";
import project04Big from "./../img/projects/04-big.jpg";

import project05 from "./../img/projects/05.jpg";
import project05Big from "./../img/projects/05-big.jpg";

import project06 from "./../img/projects/06.jpg";
import project06Big from "./../img/projects/06-big.jpg";

const projects = [
  {
    id: 0,
    title: "NikPhP",
    skills: "MySQL, MongoDB, PHP, HTML, CSS, NPM, BootStrap",
    img: project01,
    imgBig: project01Big,
    Link: "https://nikphp.ru",
  },
  {
    id: 1,
    title: "Body Shape",
    skills: "JavaScript, HTML, CSS",
    img: project02,
    imgBig: project02Big,
    gitHubLink: "https://niknovgorod.github.io/bodyshape/",
  },
  {
    id: 2,
    title: "Catalyst Analytics",
    skills: "JavaScript, HTML, CSS, NPM, BootStrap",
    img: project03,
    imgBig: project03Big,
    gitHubLink: "https://niknovgorod.github.io/catalyst/",
  },
  {
    id: 3,
    title: "Elegant Store",
    skills: "JavaScript, HTML, CSS, NPM, BootStrap",
    img: project04,
    imgBig: project04Big,
    gitHubLink: "https://niknovgorod.github.io/elegant-store/",
  },
  {
    id: 4,
    title: "Converter",
    skills: " HTML, CSS, NPM, BootStrap, API",
    img: project05,
    imgBig: project05Big,
    gitHubLink: "https://niknovgorod.github.io/converter/",
  },
  {
    id: 5,
    title: "GitHub",
    skills: "HTML, CSS, GitHub, JavaScript",
    img: project06,
    imgBig: project06Big,
    gitHubLink: "https://niknovgorod.github.io/portfolio/",
  },
];

export { projects };
